import qs from 'query-string'

/**
 * Add price filter parameter to the search URL
 */
export const addPriceParamToUrl = (href: string, price: { max?: number; min: number }): string => {
  const { query } = qs.parseUrl(href)

  if (!price.max) {
    query.price = `${price.min}__`
  } else {
    query.price = `${price.min}__${price.max}`
  }

  return qs.stringifyUrl({ url: href, query })
}
